import { rem } from 'polished';
import { Headline } from '../Typography/Typography';
import Box from '../Box/Box';
import React from 'react';
import NoSearchResultsImage from '../../images/no-search-results.svg';

export const NoSearchResults = () => (
    <Box>
        <NoSearchResultsImage />
        <Headline marginTop={rem(40)} fontWeight={500}>
            No Results Found
        </Headline>
    </Box>
);
